var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tools wrench"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49479 3.92689C6.49479 3.40328 6.84722 2.98036 7.55208 2.65814C8.25694 2.33592 9.16319 2.1748 10.2708 2.1748C12.466 2.1748 14.324 2.93485 15.8449 4.45493C17.365 5.97582 18.125 7.83383 18.125 10.029C18.125 10.5526 18.0746 11.071 17.974 11.5841C17.8733 12.098 17.7222 12.5866 17.5208 13.0498L25.8281 21.3571C26.2913 21.8203 26.5281 22.389 26.5386 23.0633C26.5483 23.7383 26.3215 24.3074 25.8583 24.7706L25.0427 25.6165C24.5795 26.0998 24.0104 26.3463 23.3353 26.356C22.6611 26.3664 22.0823 26.13 21.599 25.6467L13.2615 17.3092C12.7983 17.5106 12.3149 17.6568 11.8115 17.7478C11.308 17.838 10.8045 17.8831 10.301 17.8831C8.1059 17.8831 6.24829 17.1227 4.7282 15.6018C3.20731 14.0817 2.44687 12.2241 2.44687 10.029C2.44687 8.92133 2.60315 8.01508 2.9157 7.31022C3.22745 6.60536 3.64513 6.25293 4.16874 6.25293C4.37013 6.25293 4.55662 6.28797 4.7282 6.35805C4.89898 6.42894 5.05486 6.53487 5.19583 6.67585L8.54895 10.029L10.2708 8.33731L6.9177 4.98418C6.77673 4.84321 6.6712 4.6821 6.60112 4.50085C6.53023 4.3196 6.49479 4.12828 6.49479 3.92689Z",
    fill: "#FDE16A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.10be2a063c36bcb4f2124b3125eff550.svg";
export { ForwardRef as ReactComponent };